import Home from "../pages/user/Dashboard/Home";
import DashboardLayout from "../pages/user/Dashboard/DashboardLayout";
import OrdersLayout from "../pages/user/Orders/OrdersLayout";
import MyOrder from "../pages/user/Dashboard/MyOrder";
import PlaceOrder from "../pages/user/Orders/PlaceOrder";
import OrderDetail from "../pages/user/Dashboard/MyOrder/OrderDetails";
import StyleGuide from "../pages/user/Dashboard/StyleGuide";
import Profile from "../pages/user/Dashboard/Profile";
import Services from "../pages/services/Services";
import Stagesmart from "../pages/user/Dashboard/Stagesmart";

export const PrivateRoutes = [
  {
    path: "dashboard",
    element: <DashboardLayout />,
    children: [
      {
        path: "home",
        element: <Home />,
      },
      {
        path: "my-orders",
        element: <MyOrder />,
      },
      {
        path: "my-orders/:id",
        element: <MyOrder />,
      },
      {
        path: "style-guide",
        element: <StyleGuide />,
      },
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "services",
        element: <Services />,
      },
      {
        path: "stagesmart",
        element: <Stagesmart />,
      },
    ],
  },
  {
    path: "dashboard/my-orders/details/:id",
    element: <OrderDetail />,
  },
  {
    path: "orders",
    element: <OrdersLayout />,
    children: [
      {
        path: "place-order/:id",
        element: <PlaceOrder />,
      },
    ],
  },
];
